import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";
import {myAcademy} from "@/lib/services/academyService";

export const useApiReadStudentExam = (id) => {
    return useQuery({
        queryKey: ['student', 'exam', 'detail', id, myAcademy()],
        queryFn: () => ((async (id) => {
            return generalRequest.get(`/student/exam/${id}`)
        })(id)),
    })
}


export const useApiStudentAnswerExam = () => {
    return useMutation({
        mutationFn: (args) =>
            ((async (args) => {
                return generalRequest.post(`/student/exam/${args.id}`, args)
            })(args))
    });
}